<template>
  <v-sheet
    :color="$vuetify.theme.isDark ? '#4C4C4C33' : '#fff'"
    style="box-shadow: 0px 0px 20px 0px #0000000d"
    class="pa-3 rounded-lg">
    <v-card-title class="d-flex justify-space-between pa-0">
      <span class="font-weight-bold" style="color: var(--v-grey-500-base)">{{ title }}</span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon @click="reset" v-bind="attrs" v-on="on">
            <v-icon>mdi-autorenew</v-icon>
          </v-btn>
        </template>
        <span>Reset</span>
      </v-tooltip>
    </v-card-title>
    <v-sheet
      :color="'transparent'"
      :height="canvasHeight"
      class="d-flex justify-center align-center">
      <canvas
        :key="chartKey"
        ref="doughnutChart"
        style="width: 100%; max-width: 100%; height: auto; padding: 10px"></canvas>
    </v-sheet>
  </v-sheet>
</template>

<script>
  import { emptyDoughnutPlugin } from './plugins/emptyDoughnutPlugin';
  import Chart from 'chart.js/auto';

  const customCanvasBackgroundColor = {
    id: 'customCanvasBackgroundColor',
    beforeDraw: (chart, args, options) => {
      const { ctx, chartArea } = chart;
      ctx.save();
      ctx.fillStyle = options.color;
      ctx.fillRect(0, 0, chartArea.right, chartArea.bottom);
      ctx.restore();
    },
  };

  export default {
    name: 'DoughnutChart',
    data() {
      return {
        chartKey: '',
        chart: null,
      };
    },
    props: {
      title: {
        type: String,
        default: () => '',
      },
      type: {
        type: String,
        default: () => 'doughnut',
      },
      cutout: {
        type: String,
        default: () => 'doughnut',
      },
      data: {
        type: Object,
        default: () => {},
      },
      canvasHeight: {
        type: String,
        default: () => '',
      },
      legendPosition: {
        type: String,
        default: () => '',
      },
      labels: {
        type: Object,
        default: () => {},
      },
    },
    mounted() {
      let self = this;
      const ctx = this.$refs.doughnutChart;
      let chartConfig = {
        type: this.type,
        data: this.data,
        options: {
          responsive: true,
          maintainAspectRatio: true,
          aspectRatio: 2 | 2,
          cutout: this.cutout,
          borderWidth: 0,
          plugins: {
            customCanvasBackgroundColor: {
              color: 'transparent',
            },
            legend: {
              display: true,
              position: this.legendPosition,
              fullSize: true,
              align: 'center',
              labels: {
                usePointStyle: true,
                textAlign: 'center',
                pointStyle: 'circle',
                font: {
                  family: 'Poppins',
                  size: 12,
                },
                ...this.labels,
              },
              onClick(evt, elements, chart) {
                self.onClick_Internal(evt, elements, chart);
                self.$emit('onLegendClick', { evt, elements, chart });
              },
              onHover(e) {
                e.native.target.style.cursor = 'pointer';
              },
            },
            datalabels: {
              display: false,
            },
            emptyDoughnut: {
              color: '#666',
              text: 'No data',
              size: 16,
              width: 2,
              radiusDecrease: 1,
            },
          },
          onClick(evt, elements, chart) {
            if (!elements.length) return;

            const { labels } = evt.chart.data;

            labels.forEach((_, index) => {
              evt.chart._hiddenIndices[index] = index !== elements[0].index;
            });
            
            evt.chart.update();

            self.$emit('onClick', { evt, elements, chart });
          },
          onHover: (evt, activeEls) => {
            activeEls.length > 0
              ? (evt.chart.canvas.style.cursor = 'pointer')
              : (evt.chart.canvas.style.cursor = 'default');
          },
        },
        plugins: [emptyDoughnutPlugin, customCanvasBackgroundColor],
      };
      this.chart = new Chart(ctx, chartConfig);
    },
    methods: {
      reset() {
        this.resetChart();
        this.$emit('reset');
      },
      resetChart() {
        this.chart.getDatasetMeta(0).data.forEach((e, i) => {
          this.chart._hiddenIndices[i] = false; 
        });
        this.chart.update();
      },
      legendClickHandler(e, legendItem, legend) {
        const index = legendItem.index;
        legend.chart.toggleDataVisibility(index);
        legend.chart.update();
      },
      onClick_Internal(e, legendItem) {
        var chart = e.chart;
        if (!chart) {
          return;
        }

        const index = legendItem.index;

        chart.getDatasetMeta(0).data.forEach((e, i) => {
          chart._hiddenIndices[i] = i !== index; 
        });

        // const dataset = chart.data.datasets[0]; // Doughnut chart typically has one dataset

        // Toggle visibility of all other segments
        // chart.data.datasets[0].data.forEach((_, i) => {
        //   if (i !== index) {
        //     chart.getDatasetMeta(0).data[i].hidden = true; // Hide unselected segment
        //   } else {
        //     chart.getDatasetMeta(0).data[i].hidden = false; // Show selected segment
        //   }
        // });

        chart.update(); // Update the chart with new visibility states

        //       var index = legendItem.datasetIndex;
        // var ci = chart;
        // var alreadyHidden = (ci.getDatasetMeta(index).hidden === null) ? false : ci.getDatasetMeta(index).hidden;
        // var anyOthersAlreadyHidden = false;
        // var allOthersHidden = true;

        // // figure out the current state of the labels
        // ci.data.datasets.forEach(function(e, i) {
        //   var meta = ci.getDatasetMeta(i);

        //   if (i !== index) {
        //     if (meta.hidden) {
        //       anyOthersAlreadyHidden = true;
        //     } else {
        //       allOthersHidden = false;
        //     }
        //   }
        // });

        // // if the label we clicked is already hidden
        // // then we now want to unhide (with any others already unhidden)
        // if (alreadyHidden) {
        //   ci.getDatasetMeta(index).hidden = null;
        // } else {
        //   // otherwise, lets figure out how to toggle visibility based upon the current state
        //   ci.data.datasets.forEach(function(e, i) {
        //     var meta = ci.getDatasetMeta(i);

        //     if (i !== index) {
        //       // handles logic when we click on visible hidden label and there is currently at least
        //       // one other label that is visible and at least one other label already hidden
        //       // (we want to keep those already hidden still hidden)
        //       if (anyOthersAlreadyHidden && !allOthersHidden) {
        //         meta.hidden = true;
        //       } else {
        //         // toggle visibility
        //         meta.hidden = meta.hidden === null ? !meta.hidden : null;
        //       }
        //     } else {
        //       meta.hidden = null;
        //     }
        //   });
        // }

        // ci.update();
      },
    },
    watch: {
      data: {
        handler: function () {
          this.chart.data = this.data;
          this.chart.update();
        },
        deep: true,
      }
    }
  };
</script>
<style lang="scss">
  // .chartContainer {
  //   padding: 15px 16px;
  //   gap: 10px;
  //   border-radius: 7px;
  //   border: 1px solid #ededed99 !important;
  //   canvas {
  //     width: 100%;
  //     max-width: 100%;
  //     height: auto;
  //   }
  // }
</style>
